import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../endpoints';

export interface ActivityType {
    _id: string;
    designation: string;
    type: number;
    crudStatus?: number;
    createdAt?: string;
    updatedAt?: string;
}

export interface UpdateActivityTypeBody {
    designation?: string;
    type?: number;
    crudStatus?: number;
}

export const updateActivityType = async (activityTypeId: string, data: UpdateActivityTypeBody): Promise<any> => {
    try {
        const response: AxiosResponse<ActivityType> = await apiClient.patch(`/activities-types/${activityTypeId}`, data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface CreateActivityTypeBody {
    designation: string;
    type: number;
    crudStatus?: number;
}

export const createActivityType = async (data: CreateActivityTypeBody): Promise<any> => {
    try {
        const response: AxiosResponse<ActivityType> = await apiClient.post('/activities-types', data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
